import categories from "@/services/categories";

export const planoStats = {
    namespaced: true,
    state: {
        categories: [],
        moduleDetails: []
    },
    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories;
        },
        SET_MODULE_DETAILS(state, moduleDetails) {
            state.moduleDetails = moduleDetails;
        }
    },
    actions: {
        async fetchCategories(context) {
            const res = await categories.getAll();
            context.commit("SET_CATEGORIES", res);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/planoStats.js